import React from 'react';
import { SvgIconComponent, NotListedLocation } from '@mui/icons-material';
import { YardModel } from 'models/YardModel';
import { CarYard } from 'models/StockModel';
import Api from 'utils/api';


type ViewYardInstructionsProps = {
    icon?: SvgIconComponent,
    yard: YardModel | CarYard,
}

const ViewYardInstructions = ({icon: Icon = NotListedLocation, yard}: ViewYardInstructionsProps) => {
    if (!yard.instructions)
        return null;

    const view = (e: React.MouseEvent) => {
        e.stopPropagation();
        Api.yards
            .instructions(yard.id)
            .then(data => window.open(data.url))
    };

    return (
        <Icon
            fontSize="small"
            onClick={view}
            sx={{
                color: 'text.disabled',
                cursor: 'pointer',
                '&:hover': {
                    color: 'text.primary',
                },
            }}
        />
    );
};

export default ViewYardInstructions;
